<template>
  <div class="login">
    <h2>账号登录</h2>
    <a :href="baseInfo.steamcn_login_url" class="btn">DOTA2账号登录</a>
    <a href="" @click.prevent="handleLoginWm" class="btn wm">完美通行证登录</a>
    <button @click="handleCancel" class="x"></button>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import { DIALOG_OPTION } from '../../store/mutation-types'
import { isMobile } from '@/utils/index'

export default {
  computed: {
    baseInfo() {
      return this.$store.state.base_info
    },
  },
  methods: {
    ...mapMutations([DIALOG_OPTION]),
    handleCancel() {
      this.$store.commit(DIALOG_OPTION, {
        dialogTableVisible: false,
      })
    },
    handleLoginWm() {
      this.handleCancel()
      if (isMobile()) {
        window.location.href = this.baseInfo.wanmei_mobile_login_url
      } else {
        this.$store.state.showPwIframe = true
      }
    },
  },
}
</script>
<style lang="scss" scoped>
.login {
  position: relative;
  width: 506px;
  height: 454px;
  margin: 0 auto;
  padding-top: 96px;
  background-image: url(https://img.dota2.com.cn/file/ea/4f/ea4f088ff454879ab55cecacb57b2a4f1596528545.png);
  h2 {
    font-size: 20px;
    font-weight: bold;
    letter-spacing: 4px;
    margin-bottom: 36px;
    text-align: center;
    color: #c3f1f6;
  }
  .btn {
    width: 238px;
    height: 69px;
    line-height: 69px;
    margin: 0 auto;
    display: block;
    text-align: center;
    color: #fff;
    font-size: 20px;
    background: url(https://img.dota2.com.cn/file/85/27/8527f947e3031d5d19dea88570cf6c5b1596528676.png)
      no-repeat right top;
    transition: opacity 0.2s;
    &:hover {
      opacity: 0.8;
    }
    &.wm {
      background-position-y: bottom;
      margin-top: 40px;
    }
  }
  .x {
    position: absolute;
    right: 0px;
    top: 62px;
    width: 40px;
    height: 40px;
    cursor: pointer;
    background-image: url('../../assets/close.png');
  }
}
</style>
